const envs = {
  dev: {
    api: {
      BASE: 'https://api.dev.thinkhomewise.com',
    },
    STATIC: 'https://static.dev.thinkhomewise.com',
    WIDGETS: 'http://localhost:3000',
    APP: 'https://my.dev.thinkhomewise.com',
  },
  staging: {
    api: {
      BASE: 'https://api.staging.thinkhomewise.com',
    },
    STATIC: 'https://static.staging.thinkhomewise.com',
    WIDGETS: 'https://widgets.staging.thinkhomewise.com',
    APP: 'https://my.staging.thinkhomewise.com',
  },
  prod: {
    api: {
      BASE: 'https://api.thinkhomewise.com',
    },
    STATIC: 'https://static.thinkhomewise.com',
    WIDGETS: 'https://widgets.thinkhomewise.com',
    APP: 'https://my.thinkhomewise.com',
  },
}

const config = {
  ...envs[process.env.REACT_APP_STAGE],
}

export { config }
